import { useContext } from "react";
/**
 * This is a render-props wrapper that allows values that have been passed through a
 * React Context to be converted into Component Props without needing to add the useContext
 * to the component implementation.
 *
 * Can be used when the child component shouldn't or can't be updated to access the context
 * directly, or when refactoring data management from a pass-through approach to a context
 * based approach.
 *
 * See the test file for example usage.
 */
export const WithContext = (props) => {
    const { children } = props;
    const context = useContext(props.context);
    return children ? children(context) : null;
};
